<template lang="pug">
    include ../../media/pug/mixins
    +b.viewed-documents(
        v-bar="true"
    )
        +e.scroll-container
            +e.inner
                +e.H2.title.title._size_lg._theme_secondary {{ $t('VIEWED_DOCUMENTS') }}
                +e.container
                    +b.viewed-document(
                        v-for="item in 10"
                    )
                        +e.left.text-silver
                            +e.info
                                +e.TIME.date
                                    b 14.11.2018
                                +e.TIME.time 15:04:39
                        +e.right
                            rsl-card-item(v-bind="cardItem")


</template>

<script>
import RslCardItem from '@RSL/RslCardItem/RslCardItem';
import { mapGetters } from 'vuex';

export default {
    components: {
        RslCardItem
    },
    computed: {
        ...mapGetters([
            'isMobile',
            'isTablet',
            'getDocInfo'
        ]),
        cardItem() {
            return {
                item: this.getDocInfo,
                t: {
                    goToAbstract: 'Перейти к автореферату',
                    elOrder: 'Электронный заказ',
                    viewRecord: 'Описание',
                    docUnavailable: 'Недоступно для просмотра',
                    quotesFromText: 'Цитаты из текста',
                    seeRelDocument: 'Посмотреть связанные документы',
                    periodical: 'Периодика',
                    upLink: 'Входит в',
                    pageNumber: 'Номер страницы',
                    content: 'Содержание',
                    systemNumber: 'Системный номер',
                    storageLocation: 'Хранение',
                    consistOf: 'Состоит из',
                    moreInfo: 'Дополнительная информация'
                },
                options: {
                    cardLink: `http://dev.search.rsl.ru/ru/record/${this.$route.params.id}`,
                    isLinkViewMode: true,
                    navList: {
                        readLink: true,
                        cardLink: true
                    }
                },
                icons: {
                    more: '/sprite.svg#list',
                    lock: '/sprite.svg#lock',
                    unlock: '/sprite.svg#unlock'
                }
            };
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/components/document-views/viewed-documents.sass"></style>
